import React from 'react';

import cookie from 'react-cookies';
import PropTypes from 'prop-types';
import connect from 'react-redux/lib/connect/connect';
import bindActionCreators from 'redux/lib/bindActionCreators';

import * as PluginListDucks from 'ducks/vendors/plugin';
import * as InfoDucks from 'ducks/info/info';

import TwoColumnLayout from 'layouts/TwoColumn';
import PluginListSection from 'sections/vendors/pluginList/List';
import { NAV } from 'constants/vendors';


class PluginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: false, isInfoOpen: true };
    this.fetchData = this.fetchData.bind(this);
    this.toggleInfo = this.toggleInfo.bind(this);
  }

  componentWillMount() {
    const cookieKey = cookie.load("plugin");
    if(cookieKey) {
      this.setState({isInfoOpen: JSON.parse(cookieKey)});
    }
    this.fetchData();
  }

  fetchData(){
    this.setState({ isLoading: true });
    Promise.all([
      this.props.InfoDucks.getInformations({route: 'vendor.plugin'}),
      this.props.PluginListDucks.getPluginList(),
    ])
      .then(() => this.setState({ isLoading: false }))
      .catch(() => this.setState({ isLoading: false }));
  }

  toggleInfo(){
    const { isInfoOpen } = this.state;
    this.setState({ isInfoOpen: !isInfoOpen });
    cookie.save("plugin", !isInfoOpen);
  }

  render() {
    const {  infoList } = this.props;
    const { isInfoOpen } = this.state;
    return (
      <TwoColumnLayout 
        navInfo={NAV.PluginPage}
        infoList={infoList}
        toggleInfo={this.toggleInfo}
        isInfoOpen={isInfoOpen}
        fetchData={this.fetchData}
      >
        <PluginListSection isLoading={this.state.isLoading} />
      </TwoColumnLayout>
    );
  }
}

const mapStateToProps = (state) => ({
  infoList: InfoDucks.infoList(state),
});

const mapActionsToProps = dispatch => ({
  PluginListDucks: bindActionCreators(PluginListDucks, dispatch),
  InfoDucks: bindActionCreators(InfoDucks, dispatch),
});

PluginPage.propTypes = {
  PluginListDucks: PropTypes.object.isRequired,
  InfoDucks: PropTypes.object.isRequired,
  infoList: PropTypes.object.isRequired,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(PluginPage);